import { render, staticRenderFns } from "./violateOrders.vue?vue&type=template&id=4b96028f&"
import script from "./violateOrders.vue?vue&type=script&lang=js&"
export * from "./violateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports